<div class="py-4 px-5 bg-white mb-3 b-gray-400 d-md-flex rounded-corners align-items-start itinerary-item" >
	<div class="image mr-3 mr-md-4 mw-300 rounded-corners ">

		<a [routerLink]="[itineraryResult.destinationSlugPath]" 
			[queryParams]="{date: itineraryResult.arriveDateStr}"
			class="overflow-hidden hover-img-zoom">

			<img  *ngIf="itineraryResult.destinationAssets && itineraryResult.destinationAssets.length > 0"
				[src]="_configService.urls.basePhotoUrl + itineraryResult.destinationAssets[0].name + '?w=500&h=300&mode=crop&scale=both'"
				alt="{{itineraryResult.name}}"
				class="w-100">

			<img [src]="_configService.images.defaultImage + '?w=500&h=300&mode=crop&scale=both'"
				*ngIf="itineraryResult.destinationAssets && itineraryResult.destinationAssets.length == 0" 
				[alt]="itineraryResult.name"
				class="w-100">

			<img [src]="_configService.images.atSea + '?w=500&h=300&mode=crop&scale=both'"
				*ngIf="itineraryResult.isAtSea" 
				[alt]="itineraryResult.name"
				class="w-100">

			<img [src]="_configService.images.noExcursions + '?w=500&h=300&mode=crop&scale=both'"
				*ngIf="!itineraryResult.destinationId && !itineraryResult.isAtSea" 
				[alt]="itineraryResult.name"
				class="w-100">

		</a>
		
	</div>
	<div class="info">
		<div class="date font-weight-bold text-uppercase mb-3 body-size">
			<span>Day {{itineraryResult.day}}</span>
			<span class="mx-2 o-50">|</span>
			<span>{{itineraryResult.arriveDate | date: 'EEE, MMMM d, Y'}}</span>
		</div>
		<a [routerLink]="[itineraryResult.destinationSlugPath]"
			[queryParams]="{date: itineraryResult.arriveDateStr}"
			class=" text-primary underline-onhover">
			<h3 class="title font-family-accent font-weight-bold mb-2">
				<span>{{itineraryResult.name}}</span>
			</h3>
		</a>
		<div class="time" *ngIf="last">
			<span class="font-weight-bold">Arrives: </span>
			<span class="">{{itineraryResult.arriveTimeFormatted}}</span>
		</div>
		<div class="time" *ngIf="first">
			<span class="font-weight-bold">Departs: </span>
			<span class="">{{itineraryResult.departTimeFormatted}}</span>
		</div>
		<div class="time" *ngIf="!last && !first">
			<span class="font-weight-bold">From: </span>
			<span class="">{{itineraryResult.arriveTimeFormatted}}</span>
			<span class="mx-2">&ndash;</span>
			<span class="">{{itineraryResult.departTimeFormatted}}</span>
		</div>
		
		<a *ngIf="itineraryResult.destinationId"
			[routerLink]="[itineraryResult.destinationSlugPath]" 
			[queryParams]="{date: itineraryResult.arriveDateStr}"
			class="btn btn-outline-primary pill mt-3 mb-3 px-3 font-weight-bold">View Excursions</a>

		<div class="font-weight-bold mt-3" *ngIf="!itineraryResult.isAtSea && !itineraryResult.destinationId">No excursions offered at this port.</div>
		<div class="font-weight-bold mt-3" *ngIf="itineraryResult.isAtSea">Enjoy your cruise!</div>
	</div>
</div>
